import { RouteComponentProps, withRouter } from 'react-router-dom';

import GlobalHeader from './globalHeader';

export interface HeaderProps extends RouteComponentProps {
}

export default withRouter(GlobalHeader);